import { render } from "./UserSendDocumentResp.vue?vue&type=template&id=bc532f70"
import script from "./UserSendDocumentResp.vue?vue&type=script&lang=js"
export * from "./UserSendDocumentResp.vue?vue&type=script&lang=js"

import "./UserSendDocumentResp.vue?vue&type=style&index=0&id=bc532f70&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__